import Vue from 'vue';
import Router from 'vue-router';
import Home from "./views/Home.vue";
import RootProjects from "./views/RootProjects.vue";
import Portfolio from "./views/Portfolio.vue";
import PortfolioProject from "./views/PortfolioProject.vue";
import Projects from "./views/Projects.vue";
import SalesProjects from "./views/SalesProjects.vue";
import TrackingProjects from "./views/TrackingProjects.vue";
import TrackingInitiative from "./views/TrackingInitiative.vue";
import Costs from "./views/Costs.vue";
import ProjectIssues from "./views/ProjectIssues.vue";
import Versions from "./views/Versions.vue";
import TimeEntries from "./views/TimeEntries.vue";
import TimeEntriesDetails from "./views/TimeEntriesDetails.vue";
import UserTimeEntries from "./views/UserTimeEntries.vue";
import Callback from '@/components/Callback.vue';
import SilentCallback from '@/components/SilentCallback.vue';
import * as config from '@/utils/config';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: config.ROUTER_BASE,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/root',
            name: 'rootProjects',
            component: RootProjects,
        },
        {
            path: '/trackingInitiative',
            name: 'trackingInitiative',
            component: TrackingInitiative,
        },
        {
            path: '/trackingProjects',
            name: 'trackingProjects',
            component: TrackingProjects,
        },
        {
            path: '/portfolio',
            name: 'portfolio',
            component: Portfolio,
            meta: {
                resource: 'Portfolio',
            }
        },
        {
            path: '/portfolio/project/:id',
            name: 'portfolioProject',
            component: PortfolioProject,
            meta: {
                resource: 'PortfolioProject',
            }
        },
        {
            path: '/operations',
            name: 'projects',
            component: Projects,
            meta: {
                resource: 'Project',
            }
        },
        {
            path: '/sales',
            name: 'salesProjects',
            component: SalesProjects,
            meta: {
                resource: 'SalesProject',
            }
        },
        {
            path: '/costs',
            name: 'costs',
            component: Costs,
            meta: {
                resource: 'Costs',
            }
        },
        {
            path: '/project/:id/issues',
            name: 'projectIssues',
            component: ProjectIssues,
            meta: {
                resource: 'Issue',
            }
        },
        {
            path: '/project/:id/versions',
            name: 'versions',
            component: Versions,
            meta: {
                resource: 'ProjectVersion',
            }
        },
        {
            path: '/time-entries',
            name: 'timeEntries',
            component: TimeEntries,
            meta: {
                resource: 'TimeEntries',
            }
        },
        {
            path: '/time-entries/details',
            name: 'timeEntriesDetails',
            component: TimeEntriesDetails,
            meta: {
                resource: 'TimeEntries',
            }
        },
        {
            path: '/time-entries/details/:name',
            name: 'userTimeEntries',
            component: UserTimeEntries,
            props: true,
            meta: {
                resource: 'TimeEntries',
            }
        },
        {
            path: '/static/callback',
            name: 'callback',
            component: Callback,
        },
        {
            path: '/static/silentcallback',
            name: 'silentcallback',
            component: SilentCallback,
        }
    ]
});
